import { HttpEvent } from '@angular/common/http';
/* Copyright (C) 2020 Carlo Capuano - All Rights Reserved
 * You may use, distribute and modify this code under the
 * terms of the MIT license.
 */
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class BackendClientService {
  constructor(private httpClient: HttpClient) {}

  public get<T>(url: string): Observable<T> {
    return this.httpClient.get<T>(environment.backend + url);
  }

  public postAndObserve<T>(url: string, input: any): Observable<HttpEvent<T>> {
    return this.httpClient.post<T>(environment.backend + url, input, { reportProgress: true, observe: 'events' });
  }

  public post<T>(url: string, input: any): Observable<T> {
    return this.httpClient.post<T>(environment.backend + url, input);
  }

  public patch<T>(url: string, input: any): Observable<T> {
    return this.httpClient.patch<T>(environment.backend + url, input);
  }

  public put<T>(url: string, input: any): Observable<T> {
    return this.httpClient.put<T>(environment.backend + url, input);
  }

  public delete<T>(url: string, id: string): Observable<T> {
    return this.httpClient.delete<T>(environment.backend + url + '/' + id);
  }
}

//** interface definition coming from mongoose */
export interface PaginateResult<T> {
  docs: T[];
  totalDocs: number;
  limit: number;
  page?: number;
  totalPages: number;
  nextPage?: number | null;
  prevPage?: number | null;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  meta?: any;
  [customLabel: string]: T[] | number | boolean | null | undefined;
}
